import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Tooltip from '@mui/material/Tooltip';
import ListItemText from '@mui/material/ListItemText';
//import SidebarImageSrc from '../Images/aplus-it-services.png';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import StackedBarChartTwoToneIcon from '@mui/icons-material/StackedBarChartTwoTone';
import GridViewIcon from '@mui/icons-material/GridView';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AlarmIcon from '@mui/icons-material/Alarm';
import TableViewIcon from '@mui/icons-material/TableView';
import DevicesOtherIcon from '@mui/icons-material/DevicesOther';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import SvgIcon from '@mui/material/SvgIcon';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import SettingsRemoteOutlinedIcon from '@mui/icons-material/SettingsRemoteOutlined';

const drawerWidth = 70;

const minimizedDrawerWidth = 65;

const DrawerStyled = styled(Drawer)(({ theme }) => ({
    width: drawerWidth,
    flexShrink: 0,
    marginTop: 0,
    marginLeft: -5,
    backgroundColor: 'black',
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    '& .MuiDrawer-paper': {
        width: drawerWidth,
        marginTop: 71,
        backgroundColor: '#000410',

        marginBottom: -50,
        marginLeft: -5,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        overflowX: 'hidden',
        height: 'calc(100% - 100px)',
        display: 'flex',
        flexDirection: 'column',
    },
}));

const SidebarImage = styled('img')({
    marginTop: 'auto',
    width: '80%',
    marginLeft: '15%',
    marginBottom: '100px',
});

const WhiteIcon1 = styled(GridViewIcon)(({ theme }) => ({
    color: '#fff', // White color for the icon
    fontSize: '35px',
    margin: '2px 0',
    borderRadius: '0',
    padding: '5px',
    backgroundColor: 'transparent',
    boxShadow: 'none',
}));

const WhiteIcon2 = styled(LocationOnIcon)(({ theme }) => ({
    color: '#fff', // White color for the icon
    fontSize: '35px',
    margin: '2px 0',
    borderRadius: '0',
    padding: '5px',
    backgroundColor: 'transparent',
    boxShadow: 'none',
}));

const WhiteIcon3 = styled(AlarmIcon)(({ theme }) => ({
    color: '#fff', // White color for the icon
    fontSize: '35px',
    margin: '2px 0',
    borderRadius: '0',
    padding: '5px',
    backgroundColor: 'transparent',
    boxShadow: 'none',
}));

const WhiteIcon4 = styled(AnalyticsIcon)(({ theme }) => ({
    color: '#fff', // White color for the icon
    fontSize: '35px',
    margin: '2px 0',
    borderRadius: '0',
    padding: '5px',
    backgroundColor: 'transparent',
    boxShadow: 'none',
}));

const WhiteIcon5 = styled(TableViewIcon)(({ theme }) => ({
    color: '#fff', // White color for the icon
    fontSize: '35px',
    margin: '2px 0',
    borderRadius: '0',
    padding: '5px',
    backgroundColor: 'transparent',
    boxShadow: 'none',
}));

const WhiteIcon6 = styled(DevicesOtherIcon)(({ theme }) => ({
    color: '#fff', // White color for the icon
    fontSize: '35px',
    margin: '2px 0',
    borderRadius: '0',
    padding: '5px',
    backgroundColor: 'transparent',
    boxShadow: 'none',
}));

const WhiteIcon7 = styled(AnalyticsIcon)(({ theme }) => ({
    color: '#fff', // White color for the icon
    fontSize: '35px',
    margin: '2px 0',
    borderRadius: '0',
    padding: '5px',
    backgroundColor: 'transparent',
    boxShadow: 'none',
}));

const WhiteIcon8 = styled(ManageAccountsIcon)(({ theme }) => ({
    color: '#fff', // White color for the icon
    fontSize: '35px',
    margin: '2px 0',
    borderRadius: '0',
    padding: '5px',
    backgroundColor: 'transparent',
    boxShadow: 'none',
}));

const WhiteIcon9 = styled(NotificationsActiveIcon)(({ theme }) => ({
    color: '#fff', // White color for the icon
    fontSize: '35px',
    margin: '2px 0',
    borderRadius: '0',
    padding: '5px',
    backgroundColor: 'transparent',
    boxShadow: 'none',

}));

const WhiteIcon10 = styled(StackedBarChartTwoToneIcon)(({ theme }) => ({
    color: '#fff', // White color for the icon
    fontSize: '35px',
    margin: '2px 0',
    borderRadius: '0',
    padding: '5px',
    backgroundColor: 'transparent',
    boxShadow: 'none',
}));

const WhiteIcon11 = styled(SettingsRemoteOutlinedIcon)(({ theme }) => ({
    color: '#fff', // White color for the icon
    fontSize: '35px',
    margin: '2px 0',
    borderRadius: '0',
    padding: '5px',
    backgroundColor: 'transparent',
    boxShadow: 'none',
}));

const WhiteIconText = styled(ListItemText)({
    color: '#fff',
    fontSize: '16px',
    margin: '10px 0',
    transition: 'padding-left 0.2s, font-size 0.3s',
    paddingLeft: 20,
    '&.closed': {
        marginLeft: '240px',
        paddingLeft: 20,
    },
    '&:hover': {
        paddingLeft: 5,
        fontSize: '18px',
        background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
        borderRadius: '5px',
    },
    '&:active': {
        transform: 'scale(0.9)',
    },
    background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
    borderRadius: '5px',
    boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)',
    animation: 'pulse 2s infinite',
    '@keyframes pulse': {
        '0%': {
            transform: 'scale(1)',
        },
        '50%': {
            transform: 'scale(1.1)',
        },
        '100%': {
            transform: 'scale(1)',
        },
    },
});

const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))({
    [`& .MuiTooltip-tooltip`]: {
        backgroundColor: '#333',
        color: '#fff',
        fontSize: '12px',
        padding: '5px 9px',
        borderRadius: '6px',
        border: '2px solid #39B3D7',
        boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
    },
    [`& .MuiTooltip-arrow`]: {
        color: '#39B3D7',
    },
});

const drawerStyles = {
    paper: {
        backgroundColor: '#333',
    },
};


const activeStyle = {
    backgroundColor: 'dodgerblue', // Light blue
    border: '1px solid #FFD700', // Gold border
    //borderBottomRightRadius: '8px',
    //borderTopRightRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Subtle shadow for depth
    //padding: '2px 10px', // Padding to match icon size
    color: '#6F4E37', // Dark coffee
    fontFamily: 'Arial, sans-serif',
    fontSize: '12px', // Reduced font size for smaller text
    display: 'flex',
    alignItems: 'center',
};

const Sidebar = ({ loggedInUser }) => {
    const location = useLocation();

    return (
        <DrawerStyled
            classes={{
                paper: drawerStyles.paper,
            }}
            variant="permanent"
        >
            <List>
                <CustomTooltip title="Dashboard" arrow placement="right">
                    <ListItem button component={Link} to="/Dashboard" style={location.pathname === '/Dashboard' ? activeStyle : {}}>
                        <WhiteIcon1 />
                    </ListItem>
                </CustomTooltip>
                <CustomTooltip title="Map" arrow placement="right">
                    <ListItem button component={Link} to="/Map" style={location.pathname === '/Map' ? activeStyle : {}}>
                        <WhiteIcon2 />
                    </ListItem>
                </CustomTooltip>
                {loggedInUser && loggedInUser.ChamberEnabled && (
                    <CustomTooltip title="Pot status" arrow placement="right">
                        <ListItem button component={Link} to="/Devices" style={location.pathname === '/Devices' ? activeStyle : {}}>
                            <WhiteIcon6 />
                            <Link to="/Devices">
                            </Link>
                        </ListItem>
                    </CustomTooltip>
                )}
                {loggedInUser && loggedInUser.ChamberEnabled && loggedInUser.clientId != 509 && loggedInUser.clientId != 510 && (
                    <CustomTooltip title="Pot analytics" arrow placement="right">
                        <ListItem button component={Link} to="/PotAnalytics" style={location.pathname === '/PotAnalytics' ? activeStyle : {}}>
                            <WhiteIcon10 />
                        </ListItem>
                    </CustomTooltip>
                )}
                {loggedInUser && loggedInUser.ChamberEnabled && (
                    <CustomTooltip title="Pot alarms" arrow placement="right">
                        <ListItem button component={Link} to="/PotAlarms" style={location.pathname === '/PotAlarms' ? activeStyle : {}}>
                            <WhiteIcon3 />
                        </ListItem>
                    </CustomTooltip>
                )}
               {loggedInUser && loggedInUser.clientId != 509 && loggedInUser.clientId != 510 && (
                    <CustomTooltip title="VS analytics" arrow placement="right">
                        <ListItem
                            button
                            component={Link}
                            to="/VSAnalytics"
                            style={location.pathname === '/VSAnalytics' ? activeStyle : {}}
                        >
                            <WhiteIcon4 />
                        </ListItem>
                    </CustomTooltip>
                )}
                {loggedInUser && loggedInUser.clientId != 509 && loggedInUser.clientId != 510 && (
                    <CustomTooltip title="Station alarms" arrow placement="right">
                        <ListItem
                            button
                            component={Link}
                            to="/Alarms"
                            style={location.pathname === '/Alarms' ? activeStyle : {}}
                        >
                            <WhiteIcon9 />
                        </ListItem>
                    </CustomTooltip>
                )}
                {loggedInUser && loggedInUser.clientId != 509 && loggedInUser.clientId != 510 && (
                    <CustomTooltip title="Levels" arrow placement="right">
                        <ListItem
                            button
                            component={Link}
                            to="/VacuumLevel"
                            style={location.pathname === '/VacuumLevel' ? activeStyle : {}}
                        >
                            <WhiteIcon5 />
                        </ListItem>
                    </CustomTooltip>
                )}
                {loggedInUser && loggedInUser.VacuumLevel2CardEnabled && (
                    <CustomTooltip title="Levels (2)" arrow placement="right">
                        <ListItem button component={Link} to="/VacuumLevelTwo" style={location.pathname === '/VacuumLevelTwo' ? activeStyle : {}}>
                            <WhiteIcon5 />
                        </ListItem>
                    </CustomTooltip>
                )}
                {loggedInUser && (loggedInUser.clientId == 405 || loggedInUser.clientId == 504 || loggedInUser.clientId == 398 || loggedInUser.clientId == 511) && (
                    <CustomTooltip title="Remote Access Reset" arrow placement="right">
                        <ListItem button component={Link} to="/RemoteAccessReset" style={location.pathname === '/RemoteAccessReset' ? activeStyle : {}}>
                            <WhiteIcon11 />
                        </ListItem>
                    </CustomTooltip>
                )}
                <CustomTooltip title="User" arrow placement="right">
                    <ListItem button component={Link} to="/User" style={location.pathname === '/User' ? activeStyle : {}}>
                        <WhiteIcon8 />
                        <Link to="/User">
                        </Link>
                    </ListItem>
                </CustomTooltip>
                {loggedInUser && loggedInUser.clientId == 402 && (
                    <CustomTooltip title="Remote Access" arrow placement="right">
                        <ListItem button component={Link} to="/RemoteAccess2DP2VP" style={location.pathname === '/RemoteAccess2DP2VP' ? activeStyle : {}}>
                            <WhiteIcon11 />
                        </ListItem>
                    </CustomTooltip>
                )}
                {/*
                <CustomTooltip title="Pot Alarm" arrow placement="right">
                    <ListItem button component={Link} to="/Alarm">
                        <WhiteIcon9 />
                        <Link to="/Alarm">
                        </Link>
                    </ListItem>
                </CustomTooltip>
                <CustomTooltip title="User" arrow placement="right">
                    <ListItem button component={Link} to="/User">
                        <WhiteIcon8 />
                        <Link to="/User">
                        </Link>
                    </ListItem>
                </CustomTooltip>
                {userRole === 'Admin' && (
                    <Tooltip title="Settings" arrow placement="right">
                        <ListItem button component={Link} to="/Settings">
                            <WhiteIcon4 />
                            <Link to="/Settings">
                                <WhiteIconText primary="" />
                            </Link>
                        </ListItem>
                    </Tooltip>
                )}
                */}
            </List>
            {/*<SidebarImage src={SidebarImageSrc} alt="Sidebar Image" />*/}
        </DrawerStyled>
    );
};

export default Sidebar;